<template>
  <CommonCard>
    <div>
      <v-row style="padding: 30px;">
        <v-col cols="6">
          <span class="titulo-text">
             Familiares
          </span>
        </v-col>
        <v-col>
          <v-col cols="12" style="text-align: end;">
            <v-btn class="common-botton mr-4" @click="
              (dialogBeneficiarios = true),
              (beneficiarioId = null),
              (readOnly = false)
              " dark
              :disabled="canCreateByStatusCivil"
              v-if="canCreateBeneficiario && limiteBeneficiarios">
              Crear
            </v-btn>
          </v-col>
        </v-col>
        <!-- <v-col cols="6">
          <span class="subtitulo-text font-weight-medium">
            Porcentaje registrado:
            <strong class="active">{{ getPorcentajeRegistrado(beneficiarios) }}%</strong>
          </span>
          <br>
          <span class="subtitulo-text font-weight-medium">
            Falta por registrar:
            <strong class="inactive">{{ getPorcentajeFaltante(beneficiarios) }}%</strong>
          </span>
        </v-col> -->
      </v-row>
      <v-row style="padding: 30px; padding-top: 0px;">
        <v-col cols="12">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    <span class="text-header-table">
                      Nombre
                    </span>
                  </th>
                  <th class="text-center">
                    <span class="text-header-table">
                      Parentesco
                    </span>
                  </th>
                  <!-- <th class="text-center">
                    <span class="text-header-table">
                      Porcentaje
                    </span>
                  </th> -->
                  <th class="text-center">
                    <span class="text-header-table">
                      Fecha de alta
                    </span>
                  </th>
                  <th class="text-center">
                    <span class="text-header-table">
                      ¿Es Familiar?
                    </span>
                  </th>
                  <!-- <th class="text-center">
                    <span class="text-header-table">
                      ¿Es beneficiario?
                    </span>
                  </th> -->
                  <th class="text-center">
                    <span class="text-header-table">
                      Estatus
                    </span>
                  </th>    
                  <th class="text-center">
                    <span class="text-header-table">
                      Acciones
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in beneficiarios" :key="item.id" >
                  <td class="text-center">
                    <span class="text-table">
                      {{ getNombres(item) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span class="text-table">
                      {{ getParentesco(item) }}
                    </span>
                  </td>
                  <!-- <td class="text-center">
                    <span class="text-table">
                      {{ item.porcentaje + "%" }}
                    </span>
                  </td> -->
                  <td class="text-center">
                    <span class="text-table">
                      {{ getFormattDate(item.fechaCreacion) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span class="text-table">
                      {{ getBoolean(item.es_familiar) }}
                    </span>
                  </td>
                  <!-- <td class="text-center">
                    <span class="text-table">
                      {{ getBoolean(item.es_beneficiario) }}
                    </span>
                  </td> -->
                  <td class="text-center">
                    <span class="text-table">
                      {{ getStatus(item.status) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <v-btn icon color="primary" @click="openBeneficiarioDetalle(item.id)" class="mr-2">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn icon color="warning" @click="openBeneficiarioEdicion(item.id)" v-if="canEditBeneficiario">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </div>
    <CreateBeneficiarioModal :emision_id="polizaId" :dialog="dialogBeneficiarios" :beneficiarioId="beneficiarioId"
      :readOnly="readOnly" :currentPorcentaje="currentPorcentaje" @closeModal="dialogBeneficiarios = false" :product="product" :alianzaId="alianzaId" :beneficiarios="beneficiarios"
      @getBeneficiarios="getBeneficiariosEvent" :limiteFam="limiteFam" />
  </CommonCard>
</template>

<script>
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import moment from "moment";
import CreateBeneficiarioModal from "@/components/commonComponents/dialogs/CreateBeneficiarioModal.vue";
import { getParentescoList } from "@/services/beneficiarios/benefiario.service.js";

export default {
  components: {
    CommonCard,
    CreateBeneficiarioModal,
  },
  props: {
    beneficiarios: Array,
    estadoCivil: {
      type: String,
      required: null,
    },
    alianzaId: {
      type: Number,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      polizaId: this.$route.params.id,
      tab: 1,
      dialogBeneficiarios: false,
      beneficiarioId: null,
      readOnly: false,
      parentescoList: [],
    };
  },

  computed: {
    currentPorcentaje() {
      let total = 0;
      this.beneficiarios.map((e) => {
        total = Number(e.porcentaje) + Number(total);
      });
      return total;
    },
    canCreateByStatusCivil(){
      return this.estadoCivil != null ? false : true
    },
    canCreateBeneficiario(){
      return this.$store.getters['roles/tienePermiso']('Beneficiarios', 'Crear') 
    },
    canEditBeneficiario(){
      return this.$store.getters['roles/tienePermiso']('Beneficiarios', 'Editar') 
    },
    limiteBeneficiarios() {
      const limiteFam = this.getFamiliares(this.beneficiarios) >= 5;
      // 
      // const sinPorcentajeDisponible = this.getPorcentajeFaltante(this.beneficiarios) === 0;
      return !(limiteFam);
    },
    limiteFam() {
      return this.getFamiliares(this.beneficiarios) >= 5;
    }
  },
  methods: {
    getParentesco(item) {
      let parentesco = this.parentescoList.find((e) => e.valorSegurify == item.parentesco)
      if (!parentesco){
        const beneficiario_json = JSON.parse(item.json)
        return beneficiario_json.otroParentesco
      }
      return parentesco ? parentesco.valor : 'No disponible'
    },
    getNombres(item) {
      return `${item.nombre || ""} ${item.apellidoPaterno ||
        ""} ${item.apellidoMaterno || ""}`.trim();
    },
    getStatus(status) {
      return status === 2 ? "Inactivo" : "Activo";
    },
    getBoolean(item) {
      return item === true ? "Sí" : "No"
    },
    getFormattDate(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY");
    },
    openBeneficiarioDetalle(id) {
      this.beneficiarioId = id;
      this.dialogBeneficiarios = true;
      this.readOnly = true;
    },
    openBeneficiarioEdicion(id) {
      this.beneficiarioId = id;
      this.dialogBeneficiarios = true;
      this.readOnly = false;
    },
    getBeneficiariosEvent() {
      this.dialogBeneficiarios = false;
      this.$emit("getBeneficiarios")
    },
    async getParentescoList() {
      let response = await getParentescoList();
      this.parentescoList = response.data.parentescos
    },
    getPorcentajeRegistrado(beneficiarios) {
      let total = 0;
      for (const item of beneficiarios) {
        total += Number(item.porcentaje);
      }
      return total;
    },
    getPorcentajeFaltante(beneficiarios) {
      let total = 100;
      for (const item of beneficiarios) {
        total -= Number(item.porcentaje);
      }
      return total;
    },
    getFamiliares(benef){
      let total = 0;
      for (const item of benef) {
        if (item.es_familiar == 1) {
        total += 1;
        }
      }
      return total  
    },
    // limiteBeneficiarios() {
    //   if (this.getFamiliares(this.beneficiarios) >= 5 && this.getPorcentajeFaltante(this.beneficiarios) == 0) return false
    // }
  },
  mounted() {
    this.getParentescoList()
  }
};
</script>

<style>
.titulo-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 110%;
  color: #4d5358;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.subtitulo-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 110%;
  color: #4d5358;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.active {
  color: #4cc52d;
}

.inactive {
  color: #ce2222;
}

.text-header-table {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  color: #000000;
}

.text-table {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  color: #000000;
}

</style>
